/* eslint-disable */
import { useMemo } from 'react';
import { makeStyles, Typography } from '@material-ui/core';
import cx from 'classnames';
import { alpha } from '@material-ui/core/styles';
import { Field } from 'formik';
import CurrencyFormat from 'react-currency-format';


const useStyles = makeStyles((theme) => ({
  container: {
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
  },
  textField: {
    maxWidth: 600,
    height: 44,
    minHeight: 44,
    zIndex: 0,
    padding: '18.5px 14px',
    border: `1px solid ${alpha('#818FA0', 0.25)}`,
    borderRadius: 10,
    fontSize: theme.spacing(2),
    fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
    width: '100%',
  },
  error: {
    border: `1px solid ${theme.palette.error.main}`,
  },
  errorText: {
    color: theme.palette.error.main,
    margin: '3px 14px 0px 14px',
    fontSize: '0.75rem',
    fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
    fontWeight: 400,
    lineHeight: 1.66,
    letterSpacing: '0.03333em',
    position: 'absolute',
    bottom: 8,
  },
  lightColorBorder: {
    borderColor: alpha('#818FA0', 0.25),
  },
}));

const PriceComponent = (props) => {
  const classes = useStyles();
  const {
    row: { index: i },
    backendErrors,
    updateFieldValue,
    validateField,
  } = props;
  const index = parseInt(i);
  const name= `ispConfiguration.services[${index}].price`;

  const errors = useMemo(
    () => backendErrors
      && backendErrors[index]
      && backendErrors[index].price,
    [backendErrors],
  );

  const onUpdateFieldValue = async (key, value) => {
    updateFieldValue(index, 'price', value.replaceAll(',', ''));
    validateField(`ispConfiguration.services[${index}].price`);
  };

  function validate(value) {
    if (value === '') {
      return 'Price is a required field.'
    }
  }

  return (
    <Field type="number"
           name={`ispConfiguration.services[${index}].price`}
           validate={validate}
    >
      {({ field, form }) => {
        const error = errors
          || (form?.errors?.ispConfiguration?.services
            && form?.errors?.ispConfiguration?.services[index]?.price);
        return <div className={classes.container}>
          <CurrencyFormat
            className={cx(classes.textField,{
              [classes.error]: error
            })}
            prefix={'$ '}
            value={field.value}
            allowNegative={false}
            fixedDecimalScale={true}
            decimalScale={2}
            onChange={async (e) => {
              const value = e.target.value.replace('$ ', '');
              await form.setFieldValue(name, value);
              await onUpdateFieldValue(name, value);
            }}
            onBlur={validate}
            thousandSeparator={','}
          />
          {
            !!error && <Typography className={cx(classes.errorText)}>
              {error}
            </Typography>
          }
        </div>;
      }}
    </Field>
  );
};

export default PriceComponent;


// import { useMemo } from 'react';
// import { makeStyles, Typography } from '@material-ui/core';
// import cx from 'classnames';
// import { alpha } from '@material-ui/core/styles';
// import { Field } from 'formik';
// import CurrencyFormat from 'react-currency-format';
//
//
// const useStyles = makeStyles((theme) => ({
//   container: {
//     display: 'flex',
//     flexDirection: 'column',
//     width: '100%',
//   },
//   textField: {
//     maxWidth: 600,
//     height: 44,
//     minHeight: 44,
//     zIndex: 0,
//     padding: '18.5px 14px',
//     border: `1px solid ${alpha('#818FA0', 0.25)}`,
//     borderRadius: 10,
//     fontSize: theme.spacing(2),
//     fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
//     width: '100%',
//   },
//   error: {
//     border: `1px solid ${theme.palette.error.main}`,
//   },
//   errorText: {
//     color: theme.palette.error.main,
//     margin: '3px 14px 0px 14px',
//     fontSize: '0.75rem',
//     fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
//     fontWeight: 400,
//     lineHeight: 1.66,
//     letterSpacing: '0.03333em',
//     position: 'absolute',
//     bottom: 8,
//   },
//   lightColorBorder: {
//     borderColor: alpha('#818FA0', 0.25),
//   },
// }));
//
// const PriceComponent = (props) => {
//   const classes = useStyles();
//   const {
//     backendErrors: errors,
//     updateFieldValue,
//     validateField,
//     index,
//   } = props;
//   const name= `ispConfiguration.services[${index}].price`;
//
//   const onUpdateFieldValue = async (key, value) => {
//     updateFieldValue(index, 'price', value.replaceAll(',', ''));
//     validateField(`ispConfiguration.services[${index}].price`);
//   };
//
//   function validate(value) {
//     if (value === '') {
//       return 'Price is a required field.'
//     }
//   }
//
//   return (
//     <Field type="number"
//            name={`ispConfiguration.services[${index}].price`}
//            validate={validate}
//     >
//       {({ field, form }) => {
//         const error = errors
//           || (form?.errors?.ispConfiguration?.services
//             && form?.errors?.ispConfiguration?.services[index]?.price);
//         return <div className={classes.container}>
//           <CurrencyFormat
//             className={cx(classes.textField,{
//               [classes.error]: error
//             })}
//             prefix={'$ '}
//             value={field.value}
//             allowNegative={false}
//             fixedDecimalScale={true}
//             decimalScale={2}
//             onChange={async (e) => {
//               const value = e.target.value.replace('$ ', '');
//               await form.setFieldValue(name, value);
//               await onUpdateFieldValue(name, value);
//             }}
//             onBlur={validate}
//             thousandSeparator={','}
//           />
//           {
//             !!error && <Typography className={cx(classes.errorText)}>
//               {error}
//             </Typography>
//           }
//         </div>;
//       }}
//     </Field>
//   );
// };
//
// export default PriceComponent;
